import { convertAllPropertyToEnNumber } from 'global/default';
import { decryptId } from 'global/helperFunctions/hashquery';
import queryString from 'query-string';
import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router';

const useQuery = () => {
  const { push } = useHistory();
  const { pathname, search } = useLocation();

  const query: Record<string, any> = useMemo(() => {
    const params = queryString.parse(search);
    return convertAllPropertyToEnNumber(params, true);
  }, [search]);

  const queryStringified = (newQuery: Record<string, any>) => queryString.stringify({ ...query, ...newQuery });

  const setQuery = useCallback((newQuery: Record<string, any>) => push(pathname + '?' + queryString.stringify(newQuery)), [pathname]);

  const addQuery = useCallback((newQuery: Record<string, any>) => push(pathname + '?' + queryString.stringify({ ...query, ...newQuery })), [pathname, query]);

  const resetQuary = useCallback((defaultQuery = {}) => push(pathname + '?' + queryString.stringify({ recordsPerPage: query.recordsPerPage || 10, ...defaultQuery })), [pathname]);

  const handlePagination = useCallback(
    (pageNumber: number | undefined, recordsPerPage: number | undefined) =>
      push(pathname + '?' + queryString.stringify({ ...query, pageNumber: pageNumber || 1, recordsPerPage: recordsPerPage || 10 })),
    [pathname, query]
  );

  const pathnameArray = useMemo(() => pathname.split('/'), [pathname]);
  const pathnameLastPart = useMemo(() => pathnameArray.at(-1), [pathnameArray]);
  const decryptedPathnameLastPart = useMemo(() => (pathnameLastPart ? decryptId(pathnameLastPart) : ''), [pathnameLastPart]);

  return {
    query,
    setQuery,
    addQuery,
    resetQuary,
    queryStringified,
    pageNumber: query.pageNumber || 1,
    recordsPerPage: query.recordsPerPage || 10,
    handlePagination,
    search: location.search,
    pathname: location.pathname,
    pathnameArray,
    pathnameLastPart,
    decryptedPathnameLastPart,
    push,
  };
};

export default useQuery;
